import { render, staticRenderFns } from "./ReplaceEndUrlDomain.vue?vue&type=template&id=6d2e3eba"
import script from "./ReplaceEndUrlDomain.vue?vue&type=script&lang=js"
export * from "./ReplaceEndUrlDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports